<template>
  <div class="container presentation-container">
    <header style="background-color: #05689a;height: auto;width: 100%;padding: 25px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-logo-white.png"  height="68" width="230" alt="Logo">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/realshield-logo-white.png"  height="68" width="230" alt="Logo">
          <img v-else src="../../../public/assets/images/orep-white-logo.png"  height="68" width="230" alt="Logo">
        </div>
      </div>
    </header>
    <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px;">

      <div class="row">
        <div class="col-md-8">
          <p class="comic-font-bold" style="font-size: 30px; color: #05689a">
            <strong>Real Estate Appraisers Errors & Omissions</strong>
          </p>
          <p class="comic-font-bold" style="font-size: 30px;">
            PREMIUM PROPOSAL
          </p>
        </div>
        <div class="col-md-auto text-center">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-call.png" alt="18 years">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/mercer-call.png" alt="18 years">
          <img v-else src="../../../public/assets/images/call-1.png" alt="18 years">
        </div>
      </div>
      <hr class="new1" />

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <p class="comic-font-bold" style="font-size: 20px;">
                PREMIUM PREPARED FOR: {{ axApplication.fullLegalNameOfAppraiser }}
              </p>
            </div>
          </div>

          <hr class="new1">
        </div>

      </div>
      <div class="row" style="margin-top: 20px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-auto text-left">
          <table class="">
            <tbody>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>LIMITS OF COVERAGE:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder=coverage()   style="width: 500px;" disabled>
              </td>
            </tr>
            <tr>
              <td style="margin-bottom: 3rem !important;">
                <strong>Deductible:</strong>
              </td>
              <td>
                <input placeholder="$0 (by OREP Membership endorsement)" style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>PREMIUM:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder="'$'+(state.premium).toFixed(2)"   style="width: 500px;" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <strong>OREP Member Fee:</strong>
              </td>
              <td>
                <input :placeholder="'$'+orepfee().toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <input type="checkbox"  class="big-checkbox" v-model="axApplication.cyberTechnologyCoverage" style="margin-right: 8px;">
                <strong>Optional $100K
                <a href="https://orep.org/100K-cyber-coverage" target="_blank" class="coverage-link">
                  Cyber Coverage
                </a>:</strong>
              </td>
              <td>
                <input :placeholder="'$' + (state.premiumCyberTechnologyCoverage).toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>

            <tr v-if="axApplication.traineeCoverage">
              <td>
                <strong>Appraiser Trainee Coverage:</strong>
              </td>
              <td>
                <input type="text" :placeholder="'$'+(state.premiumTraineeCoverage).toFixed(2)"   style="width: 500px;" disabled>
              </td>
            </tr>
            <tr  v-if="axApplication.mgmtCoverage">
              <td>
                <strong>Real Estate AMC Extension:</strong>
              </td>
              <td>
                <input :placeholder="'$'+(state.premiumMgmtCoverage).toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>
            <tr  v-if="axApplication.customer.state == 'CT' || axApplication.customer.state == 'NY' || axApplication.customer.state == 'FL' || axApplication.customer.state == 'NJ' || axApplication.customer.state == 'MA' || axApplication.customer.state == 'KY'">
              <td>
                <strong>State Tax:</strong>
              </td>
              <td>
                <input v-if = "state.stateTax == '0'" :placeholder="'Agent to Calculate'" style="width: 500px;" disabled>
                <input v-else :placeholder="'$'+(state.stateTax).toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>TOTAL:</strong>
                </p>
              </td>
              <td>
                <input :placeholder="'$'+(total()+orepfee()).toFixed(2)" style="width: 500px;" disabled>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="row">
            <div class="col-md-auto text-left">
              <p>
                <strong>
                  <i>Please Note:</i>
                </strong>
                Your Insurance Policy is not in effect/bound until Payment or Down-Payment is received. <strong style="text-decoration: underline">To expedite coverage and avoid delays, please use one of these two links to make payment now.</strong>
              </p>
            </div>
            <div class="d-flex my-5" v-if="state.premium !== 0">
<!--              <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">-->
<!--                <input name="TaxItem" type="hidden" value="n">-->
<!--                <input name="AddEmail" type="hidden" value="appraisers@orep.org">-->
<!--                <input name="ID" type="hidden" value="Premium">-->
<!--                <input name="ID" type="hidden" value="OREP Fee">-->
<!--                <input name="Price" type="hidden" :value="(total()).toFixed(2)">-->
<!--                <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">-->
<!--                <input name="Multi" type="hidden" value="Y">-->
<!--                <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                       name="Submit" type="submit" value="PAY IN FULL NOW">-->
<!--              </form>-->
              <button type="submit" :disabled="!state.pageSixIsValid" :class="{submitDisabled: !state.pageSixIsValid}"
                      class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                      @click="navigateToNext('ax-application-payment')">PAY IN FULL NOW</button>
              <router-link
                :to="{name: 'ax-application-request-financing', params: {id: axApplication.id}}"
                class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                target="_blank"
                v-if="axApplication.customer.state === 'KY'"
              >
                REQUEST FINANCING
              </router-link>

<!--              <a v-if="getApplicantType === 'Mercer'"-->
<!--                 v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ axApplication.firmNameOfAppraiser+'&ia_name='+axApplication.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(axApplication.customer.address)+'&city='+axApplication.customer.city+'&state_code='+axApplication.customer.state+'&zip='+axApplication.customer.zipCode+'&phone='+axApplication.customer.phone+'&email='+axApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+(total()).toFixed(2)"-->
<!--                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                 target="_blank">REQUEST FINANCING</a>-->
<!--              <a v-else-if="getApplicantType === 'Realshield'"-->
<!--                 v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ axApplication.firmNameOfAppraiser+'&ia_name='+axApplication.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(axApplication.customer.address)+'&city='+axApplication.customer.city+'&state_code='+axApplication.customer.state+'&zip='+axApplication.customer.zipCode+'&phone='+axApplication.customer.phone+'&email='+axApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+(total()).toFixed(2)"-->
<!--                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                 target="_blank">REQUEST FINANCING</a>-->
              <a v-if="axApplication.customer.state !== 'KY' && axApplication.cyberTechnologyCoverage === false"
                 v-bind:href="this.state.requestFinancingPaymentLinkWithOutCyberTechnology"
                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                 target="_blank">REQUEST FINANCING</a>
              <a v-else-if="axApplication.customer.state !== 'KY' && axApplication.cyberTechnologyCoverage === true"
                 v-bind:href="this.state.requestFinancingPaymentLinkWithCyberTechnology"
                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                 target="_blank">REQUEST FINANCING</a>
            </div>
            <div v-if="getApplicantType === 'OREP'" class="col-md-auto text-left small">
              <p class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  If you are new to OREP, please email a copy of your Expiring Declarations Page to
                  <strong><a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a></strong>
                </span>
              </p>
            </div>
          </div>
        </div>

      </div>

      <hr class="new1" />
      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          PROGRAM HIGHLIGHTS
        </p>
      </div>

      <div class="row" style="margin-top: 30px">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">

          <ul>
            <li style="padding-bottom:1em">$10,000 Disciplinary Proceedings Coverage</li>
            <li style="padding-bottom:1em">Broad Coverage for Appraisers: Coverage for Residential, Commercial, Right of Way Appraisals</li>
            <li style="padding-bottom:1em">Inexpensive Option to Add Trainee Coverage</li>
            <li style="padding-bottom:1em">$25,000 Subpoena Assistance</li>
            <li style="padding-bottom:1em">Loss of Earning: $500 a day, $10,000 maximum.</li>
            <li style="padding-bottom:1em">AMC Extension Coverage Available</li>
            <li style="padding-bottom:1em">FREE extended reporting period in case of disability/death</li>
            <li style="padding-bottom:1em">FREE extended reporting period upon retirement (for qualified applicants)</li>
            <li>OREP Serving Appraiser’s E&O Insurance Needs over 20 Years</li>


          </ul>
        </div>
      </div>

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          WHY OREP?
        </p>
      </div>
      <div class="row" style="margin-top: 30px;margin-bottom: 50px;">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">

          <ul>
            <li style="padding-bottom:1em">14 Hours FREE CE for Appraisers (<a href="https://orep.org/list-approved-ce/" target="_blank">click for List of Approved States</a>)</li>
            <li style="padding-bottom:1em">Free State Board Complaint Consulting</li>
            <li style="padding-bottom:1em">Free Risk Management and Claims Support</li>
            <li style="padding-bottom:1em">Guaranteed Delivery of Working RE Magazine</li>

          </ul>
        </div>
      </div>
      <div class="row" style="margin-top: 30px;margin-bottom: 50px;">
        <div class="col-md-2 text-center">
        </div>
        <div class="col-md-9 text-left">
          <div class="d-flex my-5" v-if="state.premium !== 0">
<!--            <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">-->
<!--              <input name="TaxItem" type="hidden" value="n">-->
<!--              <input name="AddEmail" type="hidden" value="appraisers@orep.org">-->
<!--              <input name="ID" type="hidden" value="Premium">-->
<!--              <input name="ID" type="hidden" value="OREP Fee">-->
<!--              <input name="Price" type="hidden" :value="(total()).toFixed(2)">-->
<!--              <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">-->
<!--              <input name="Multi" type="hidden" value="Y">-->
<!--              <input class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                     name="Submit" type="submit" value="PAY IN FULL NOW">-->
<!--            </form>-->
            <button type="submit" :disabled="!state.pageSixIsValid" :class="{submitDisabled: !state.pageSixIsValid}"
                    class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                    @click="navigateToNext('ax-application-payment')">PAY IN FULL NOW</button>
            <router-link
              :to="{name: 'ax-application-request-financing', params: {id: axApplication.id}}"
              class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
              target="_blank"
              v-if="axApplication.customer.state === 'KY'"
            >
              REQUEST FINANCING
            </router-link>

<!--            <a v-if="getApplicantType === 'Mercer'"-->
<!--               v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ axApplication.firmNameOfAppraiser+'&ia_name='+axApplication.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(axApplication.customer.address)+'&city='+axApplication.customer.city+'&state_code='+axApplication.customer.state+'&zip='+axApplication.customer.zipCode+'&phone='+axApplication.customer.phone+'&email='+axApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+(total()).toFixed(2)"-->
<!--               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--               target="_blank">REQUEST FINANCING</a>-->
<!--            <a v-else-if="getApplicantType === 'Realshield'"-->
<!--               v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ axApplication.firmNameOfAppraiser+'&ia_name='+axApplication.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(axApplication.customer.address)+'&city='+axApplication.customer.city+'&state_code='+axApplication.customer.state+'&zip='+axApplication.customer.zipCode+'&phone='+axApplication.customer.phone+'&email='+axApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+(total()).toFixed(2)"-->
<!--               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--               target="_blank">REQUEST FINANCING</a>-->
            <a v-if="axApplication.customer.state !== 'KY' && axApplication.cyberTechnologyCoverage === false"
               v-bind:href="this.state.requestFinancingPaymentLinkWithOutCyberTechnology"
               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
               target="_blank">REQUEST FINANCING</a>
            <a v-else-if="axApplication.customer.state !== 'KY' && axApplication.cyberTechnologyCoverage === true"
               v-bind:href="this.state.requestFinancingPaymentLinkWithCyberTechnology"
               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
               target="_blank">REQUEST FINANCING</a>
          </div>
        </div>
      </div>
    </div>

    <footer v-if="getApplicantType === 'Mercer'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/mercer-logo-white.png" height="68" width="230" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

    </footer>
    <footer v-else-if="getApplicantType === 'Realshield'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/realshield-logo-white.png" height="68" width="230" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

    </footer>
    <footer v-else style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/white-logo.png" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC || CA License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            appraisers@OREP.org
          </p>
        </div>
      </div>

    </footer>
  </div>

</template>

<script>
import $ from "jquery";
import moment from "moment";
export default {

  name: "ax-application-representation",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    axApplication() {
      return this.$store.state.axApplication.axApplication;
    },
    state() {
      return this.$store.state.axApplication;
    },
    errorMsg() {
      return this.$store.state.axApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ax-application-amba' || first === '/portal/ax-application-amba/' || this.axApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ax-application-realshield' || first === '/portal/ax-application-realshield/' || this.axApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  created: function(){
    if (this.state.premium == 0){
      window.location.href = "https://orep.org/appraiser-portal-payment/"
      // this.$router.push('https://orep.org/appraiser-portal-payment/')
    }
  },
  methods: {

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    getEffectiveDate() {
      return moment.utc(this.state.axApplication.effectiveDate).format('MM/DD/YYYY');
    },
    total() {
      if (this.state.premium !== 0) {
        let total = this.state.premium;

        if (this.axApplication.firstCoverage) {
          total += this.state.premiumFirstCoverage;
        }
        if (this.axApplication.traineeCoverage) {
          total += this.state.premiumTraineeCoverage;
        }
        if (this.axApplication.mgmtCoverage) {
          total += this.state.premiumMgmtCoverage;
        }

        total = total + this.checkCyberTechnologyCoverage();
        return total + this.state.stateTax;
      }
      else {
        return 0;
      }
    },
    coverage() {
      switch (this.axApplication.limitOfCoverage) {
        case '0.3M/0.6M':
          return '$300,000 / $600,000';
        case '0.5M/1M':
          return '$500,000 / $1,000,000';
        case '1M/1M':
          return '$1,000,000 / $1,000,000';
        default:
          return '$1,000,000 / $2,000,000';
      }
    },
    orepfee() {
      // if (this.axApplication.customer.state === 'CO' || this.axApplication.customer.state === 'FL') {
      if (this.axApplication.customer.state === 'CO') {
        return 60;
      }
      else {
        if (this.state.premium !== 0) {
          return 60;
        }
        else {
          return 60;
        }
      }
    },

    checkCyberTechnologyCoverage() {
      // if (this.axApplication.customer.state === 'CO' || this.axApplication.customer.state === 'FL') {
      if (this.axApplication.cyberTechnologyCoverage) {
        this.state.premiumCyberTechnologyCoverage = 125;
        return this.state.premiumCyberTechnologyCoverage;
      }
      return 0;
    },

  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top
    }, 500);
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
li{
  margin: 12px 0;
}
table td {
  padding: 0 5px 15px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


::placeholder {
  color: black;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}
.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans';
}
.comic-font-bold{
  font-family: 'Open Sans';
  font-weight: bold;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}

.coverage-link {
  text-decoration: none;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  color: #046085;
}

.coverage-link:hover {
  text-decoration: underline;
}

.big-checkbox {
  transform: scale(2); /* makes checkbox twice as big */
  margin-right: 12px; /* add spacing after checkbox */
  cursor: pointer; /* show pointer cursor */
}

</style>
